import React from "react";

export type Api = {
  triggerAuthentication: () => void;
};

export const ApiContext = React.createContext<Api | undefined>(undefined);
